import { render, staticRenderFns } from "./Egressos.vue?vue&type=template&id=3f4b7d20&scoped=true&lang=pug&"
import script from "./Egressos.vue?vue&type=script&lang=js&"
export * from "./Egressos.vue?vue&type=script&lang=js&"
import style0 from "./Egressos.styl?vue&type=style&index=0&id=3f4b7d20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b7d20",
  null
  
)

export default component.exports